/**
 * Progresso de aceites de um pacote de troca.
 *
 * Recebe o pacote (não o AdminQueueResponse) para servir tanto à tabela de
 * aprovações quanto à página de detalhes da troca em transição.
 */
import { InviteStatus } from '@/Network/Types/Requests/HandoverInviteRequests'
import type { PackageResponse } from '@/Network/Types/Responses/HandoverInviteResponses'

type PackageInvites = Pick<PackageResponse, 'invites'>

export const getInviteCount = (pkg: PackageInvites): number => pkg.invites.length

// Conta pelo status atual: um aceite cancelado (pacote que voltou da fila)
// mantém o acceptedAt histórico, mas não é mais um aceite.
export const getAcceptedCount = (pkg: PackageInvites): number =>
  pkg.invites.filter((invite) => invite.status === InviteStatus.ACCEPTED).length

export const getAcceptedPercent = (pkg: PackageInvites): number => {
  const total = getInviteCount(pkg)
  return total === 0 ? 0 : Math.round((getAcceptedCount(pkg) / total) * 100)
}
